import { Currency } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"

export interface IGetExchangeRateRequest {
    date: Dayjs
    currency: Currency
}

export interface IGetExchangeRateRequestDto {
    date: string
    currency: Currency
}

export interface IGetExchangeRateDto {
    date: string
    currency: Currency
    conversionRate: number
}

export default class ExchangeRate {
    date: Dayjs
    currency: Currency
    conversionRate: number

    constructor(dto: IGetExchangeRateDto) {
        this.date = dayjs.utc(dto.date, "YYYY-MM-DD")
        this.currency = dto.currency
        this.conversionRate = dto.conversionRate
    }

    get id(): string {
        return getExchangeRateID({ date: this.date, currency: this.currency })
    }

    static getRequestDto(data: IGetExchangeRateRequest) {
        return {
            date: data.date.format("YYYY-MM-DD"),
            currency: data.currency,
        }
    }
}

export function getExchangeRateID({ date, currency }: IGetExchangeRateRequest) {
    return `${currency}_${date.format("YYYY-MM-DD")}`
}
